module.exports = __webpack_public_path__ + "static/media/beach-bar.fbc5efa3.jpg";